import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  paymentReminderModalTitle: {
    defaultMessage: 'Send Payment Reminder',
    id: '2Su0SW',
    description: 'Title for the payment reminder modal',
  },
  paymentReminderModalDescription: {
    defaultMessage:
      'You can re-send the payment reminder email to your customer to confirm the exchange. Enter the recipient email address (for multiple emails, separate with a comma or press enter).',
    id: 'TmFFrX',
    description: 'Description text for the payment reminder modal',
  },
  triggerButtonText: {
    defaultMessage: 'Send Payment Reminder',
    id: 'Kc68Ud',
    description: 'Label for the send payment reminder button',
  },
  sendPaymentSuccessTitle: {
    description: 'Title for a success message after sending a payment reminder',
    defaultMessage: 'Payment reminder sent!',
    id: 'g6vGQG',
  },
  sendPaymentSuccessContent: {
    description: 'Content for a success message after sending a payment reminder',
    defaultMessage: 'The payment reminder has been sent to {count, plural, one {# recipient} other {# recipients}} successfully.',
    id: 'w1GBpw',
  },
});
